import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    height: '100%',
    display: 'flex',
    width: 1,
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center'
  }
});
